module.exports = __webpack_public_path__ + "static/img/success-icon.b6fac04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success-icon.png
// module id = qzx+
// module chunks = 36